
<template>
  <div style="height: 100vh;width: 100vw">
    <van-search v-model="searchValue" show-action placeholder="请输入搜索关键词" @input="input" />
    <van-tabs title-active-color="#0ec9ac" @click="changeTabs" v-model="active">
      <van-tab title="药品" :name="1"></van-tab>
      <van-tab title="收费项" :name="2"></van-tab>
    </van-tabs>
    <div v-if="active===1" style="height: calc(100% - 100px);overflow-y: scroll">
      <van-empty v-if="sfxm.length == 0" description="暂无药品信息！" />
      <van-list
          v-else
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="querySfxmlList"
      >
        <div v-for="(item, index) in sfxm" :key="index"
             style="display: flex; gap: 10px; padding: 12px; border: 1px solid #e0e0e0; border-radius: 8px;
            background-color: #ffffff; box-shadow: 0 2px 4px rgba(0,0,0,0.05); margin:8px;">
          <!-- 左侧信息区 -->
          <div style="width: 70%; display: flex; flex-direction: column; justify-content: center;">
            <h3 style="margin: 0 0 8px 0; font-size: 16px; color: #1a1a1a; font-weight: 600;">
              {{ item.xmmc }}
            </h3>
            <div style="font-size: 14px; color: #555;">
              <span style="color: #777; font-weight: 500;">药品规格：</span>
              <span>{{ item.gg }}</span>
            </div>
          </div>
          <!-- 右侧价格区 -->
          <div style="width: calc(30% - 10px); display: flex; flex-direction: column; justify-content: center; align-items: flex-end; text-align: right;">
            <div style="font-size: 16px; font-weight: bold; color: #d32f2f;">
              ￥{{ item.dj }}
              <span style="font-size: 12px; font-weight: normal; color: #777;">/{{ item.dw }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div v-else-if="active===2" style="height: calc(100% - 100px);overflow-y: scroll">
      <van-empty v-if="sfxm.length == 0" description="暂无收费项目信息！" />
      <van-list
          v-else
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="querySfxmlList"
      >
        <div v-for="(item, index) in sfxm" :key="index"
             style="display: flex; gap: 10px; padding: 12px; border: 1px solid #e0e0e0; border-radius: 8px;
            background-color: #ffffff; box-shadow: 0 2px 4px rgba(0,0,0,0.05); margin:8px;">
          <!-- 左侧信息区 -->
          <div style="width: 65%; display: flex; flex-direction: column; justify-content: center;">
            <h3 style="margin: 0 0 8px 0; font-size: 16px; color: #1a1a1a; font-weight: 600;">
              {{ item.xmmc }}
            </h3>
            <div style="font-size: 14px; color: #555;">
              <span style="color: #777; font-weight: 500;">项目编码：</span>
              <span>{{ item.xmbh }}</span>
            </div>
          </div>
          <!-- 右侧价格区 -->
          <div style="width: calc(35% - 10px); display: flex; flex-direction: column; justify-content: center; align-items: flex-end; text-align: right;">
            <div style="font-size: 16px; font-weight: bold; color: #d32f2f;">
              ￥{{ item.dj }}
              <span style="font-size: 12px; font-weight: normal; color: #777;">/{{ item.dw }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import {getSfxmList} from "@/api/sfxm";

export default {
  data() {
    return {
      searchValue:null,
      active:1,
      pageNo:1,
      pageSize:10,
      loading: false,// 当loading为true时，转圈圈
      finished: false,// 数据是否请求结束，结束会先显示- 没有更多了 -
      sfxm:[]
    }
  },
  methods:{
    //搜索的内容
    input(){
      console.log("搜索的内容---------:",this.searchValue)
      this.pageNo=1
      this.sfxm=[]
      this.querySfxmlList();
    },
    //切换类别
    changeTabs(){
      console.log("切换类别-----------:",this.active)
      this.pageNo=1
      this.sfxm=[]
      this.querySfxmlList();
    },
    // 查询收费项目
    querySfxmlList() {
      getSfxmList({lb:this.active,cxm:this.searchValue,ym:this.pageNo,myhs:this.pageSize}).then(res => {
        if (res.success) {
          this.loading = false;
          //通过concat()将两个集合拼接
          this.sfxm = this.sfxm.concat(res.result);
          this.pageNo++;
          // 校验是否加载完毕
          if (res.result.length === 0) {
            this.finished = true;
          }else{
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
  }
}
</script>

<style>
.van-tabs__line {
  background-color: #0ec9ac;
}
</style>